/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React from 'react';
import {
    ATTRIBUTION_MODE_CHERRYPICK,
    USER_RELATIONSHIP_ATTRIBUTION_ON,
} from '../../../contexts/AbstractContext';
import {
    FETCH_MODE_FEED,
    Provider as CommunityContextProvider,
} from '../../../contexts/CommunityContext';
import { Consumer as PageConsumer } from '../../../contexts/PageContext';
import { PageContext } from '../../../contexts/ContextCreator';
import MobileWandTrigger from '../../CallToAction/MobileWandTrigger/MobileWandTrigger';
import CreateContentWidgetV2 from '../../Content/CreateContentWidgetV2/CreateContentWidgetV2';
import MasterFeedTitleCard from '../../Content/Feed/Components/MasterFeedTitleCard/MasterFeedTitleCard';
import Feed from '../../Content/Feed/Feed';
import LeftRailContent from '../../LeftRailLayout/LeftRailContent/LeftRailContent';
import Layout from '../Layout';
import ThreeColumnLayout from '../ThreeColumnLayout/ThreeColumnLayout';
import RightRailContent from './RightRailContent/RightRailContent';
import TitleCard from './TitleCard/TitleCard';
import PostBoxContainer from '../../UnifiedPostBox/PostBoxContainer/PostBoxContainer';

import './ThreeColumnGridLayout.scss';

export default class ThreeColumnGridLayout extends React.PureComponent {
    isProfileCTARendered = () => {
        const { isMobile, pageProps = {} } = this.context;
        if (!isMobile) return false;

        const { allowProfileCTA } = this.props;
        const {
            headerProps: { jobProfileSnippet: { isCompleted } = {} } = {},
            featureFlags: { onSiteCTA } = {},
        } = pageProps;

        if (!onSiteCTA || !allowProfileCTA) return false;

        return !isCompleted;
    };

    defaultLeftRailContent = () => (
        <LeftRailContent
            allowProfileCTA={this.props.allowProfileCTA}
            displayLeftRailFooter={!this.props.displayDesktopFooter}
            profileLeftRailCTAProps={this.props.profileLeftRailCTAProps}
        />
    );

    renderCreateContentWidget = () => {
        const { showCreateContentWidget, currentTopic } = this.props;
        const {
            pageProps: { featureFlags },
        } = this.context;

        if (!showCreateContentWidget || currentTopic) return null;

        return featureFlags.unifiedPostBox ? (
            <PostBoxContainer />
        ) : (
            <CreateContentWidgetV2
                defaultPostLocation={this.props.currentTopic}
            />
        );
    };

    renderTitleCard = () => {
        return this.props.hasTitleCard && this.props.currentTopic ? (
            <TitleCard currentTopic={this.props.currentTopic} />
        ) : null;
    };

    showSingleContentFeed = () => {
        const { pageProps } = this.context;
        const { featureFlags } = pageProps;

        return (
            this.props.showSingleContentFeed && (
                <React.Fragment>
                    <MasterFeedTitleCard />
                    {featureFlags.unifiedPostBox ? (
                        this.context.wrapAuth(
                            'CreateContent',
                            <PostBoxContainer />,
                            { login_trigger: 'create-content' }
                        )
                    ) : (
                        <CreateContentWidgetV2
                            defaultPostLocation={this.props.currentTopic}
                        />
                    )}
                    <CommunityContextProvider
                        fetchMode={FETCH_MODE_FEED}
                        attributionMode={ATTRIBUTION_MODE_CHERRYPICK}
                        content={[]}
                        userRelationshipMode={USER_RELATIONSHIP_ATTRIBUTION_ON}
                        topics={this.props.topics}
                    >
                        <Feed
                            feedGroup="GlobalFeed"
                            feedGroupId="master"
                            feedType="masterFeed"
                        />
                    </CommunityContextProvider>
                </React.Fragment>
            )
        );
    };

    renderMobileWand = () => {
        const { modals } = this.context;
        return !modals.type ? (
            <MobileWandTrigger currentTopic={this.props.currentTopic} />
        ) : null;
    };

    render() {
        return (
            <div className="component-Layout-ThreeColumnGridLayout">
                <PageConsumer>
                    {(context) => {
                        return (
                            <Layout
                                PAGE_PROPS={context.getPageProps()}
                                hasBottomBanner={this.props.hasBottomBanner}
                                hasChangingContainer={false}
                                fullScreenStyling
                                displayDesktopFooter={
                                    this.props.displayDesktopFooter
                                }
                            >
                                <ThreeColumnLayout>
                                    <ThreeColumnLayout.LeftRail>
                                        {this.props.leftRailContent ||
                                            this.defaultLeftRailContent()}
                                    </ThreeColumnLayout.LeftRail>
                                    <ThreeColumnLayout.MainContent>
                                        {this.renderTitleCard()}
                                        {this.renderCreateContentWidget()}
                                        {this.props.children}
                                        {this.showSingleContentFeed()}
                                        {this.props.showMobileWand
                                            ? this.renderMobileWand()
                                            : null}
                                    </ThreeColumnLayout.MainContent>
                                    <ThreeColumnLayout.RightRail>
                                        <RightRailContent
                                            contents={
                                                this.props.rightRailContent
                                            }
                                        />
                                    </ThreeColumnLayout.RightRail>
                                </ThreeColumnLayout>
                            </Layout>
                        );
                    }}
                </PageConsumer>
            </div>
        );
    }
}

ThreeColumnGridLayout.contextType = PageContext;

ThreeColumnGridLayout.propTypes = {
    /**
     * leftRailContent
     */
    leftRailContent: PropTypes.node,
    /**
     * main content
     */
    children: PropTypes.node.isRequired,
    /**
     * right rail content
     */
    rightRailContent: PropTypes.arrayOf(PropTypes.string),
    /**
     * Required if need mini feed
     */
    currentTopic: PropTypes.object,
    /**
     * bool to show create content widget or not
     */
    showCreateContentWidget: PropTypes.bool,
    /**
     * bool to show bottom banner or not
     */
    hasBottomBanner: PropTypes.bool,
    /**
     * bool to show mobile wand toggle or not
     */
    showMobileWand: PropTypes.bool,
    showSingleContentFeed: PropTypes.bool,
    hasTitleCard: PropTypes.bool,
    displayDesktopFooter: PropTypes.bool,
    /**
     * whether Profile CTA option is on if other checks pass.
     */
    allowProfileCTA: PropTypes.bool,
};

ThreeColumnGridLayout.defaultProps = {
    displayDesktopFooter: false,
    hasTitleCard: false,
    showSingleContentFeed: false,
    showMobileWand: false,
    showCreateContentWidget: true,
    hasBottomBanner: false,
    allowProfileCTA: false,
};
